import { HeroSettings } from '../../types';
import { exportToExcel, printAsExcel } from '../../utils/exportToExcel';

export function exportHero(heroSettings: HeroSettings) {
  exportToExcel([{
    'Section': 'Hero Settings', 'Company Name': heroSettings.companyName, 'Subtitle': heroSettings.companySubtitle,
    'Mission Line 1': heroSettings.missionLine1, 'Mission Line 2': heroSettings.missionLine2, 'Mission Line 3': heroSettings.missionLine3,
    'Primary Button': heroSettings.primaryButtonText, 'Secondary Button': heroSettings.secondaryButtonText,
    'Status': heroSettings.isActive ? 'Active' : 'Inactive', 'Last Updated': new Date(heroSettings.updatedAt).toLocaleString(), 'Updated By': heroSettings.updatedBy
  }], `hero_settings_${new Date().toISOString().split('T')[0]}`);
}

export function exportServices(apiServices: any[]) {
  exportToExcel(apiServices.map((s: any) => ({
    'Icon': s.icon, 'Title': s.title, 'Description': s.description, 'Display Order': s.displayOrder, 'Status': s.isActive ? 'Active' : 'Inactive'
  })), `services_${new Date().toISOString().split('T')[0]}`);
}

export function exportFleet(apiFleetVessels: any[]) {
  exportToExcel(apiFleetVessels.map((v: any) => ({
    'Name': v.name, 'Type': v.type, 'Icon': v.icon, 'Description': v.description,
    'Features': Array.isArray(v.features) ? v.features.join(', ') : '', 'Display Order': v.displayOrder, 'Status': v.isActive ? 'Active' : 'Inactive'
  })), `fleet_${new Date().toISOString().split('T')[0]}`);
}

export function exportContacts(apiContactOffices: any[]) {
  exportToExcel(apiContactOffices.map((o: any) => ({
    'Office Name': o.name, 'Type': (o.officeType || '').charAt(0).toUpperCase() + (o.officeType || '').slice(1),
    'Country': o.country, 'City': o.city, 'Address': `${o.addressLine1 || ''}${o.addressLine2 ? ', ' + o.addressLine2 : ''}`,
    'Phone Numbers': Array.isArray(o.phoneNumbers) ? o.phoneNumbers.join(', ') : '', 'Email': o.email, 'Status': o.isActive ? 'Active' : 'Inactive'
  })), `contact_offices_${new Date().toISOString().split('T')[0]}`);
}

export function printTab(activeTab: string, heroSettings: HeroSettings, apiServices: any[], apiFleetVessels: any[], apiContactOffices: any[]) {
  const tabDataMap: Record<string, any[]> = {
    hero: [{ 'Company Name': heroSettings.companyName, 'Subtitle': heroSettings.companySubtitle, 'Mission Line 1': heroSettings.missionLine1, 'Mission Line 2': heroSettings.missionLine2, 'Mission Line 3': heroSettings.missionLine3, 'Status': heroSettings.isActive ? 'Active' : 'Inactive' }],
    services: apiServices.map((s: any) => ({ 'Title': s.title, 'Description': s.description, 'Order': s.displayOrder, 'Status': s.isActive ? 'Active' : 'Inactive' })),
    fleet: apiFleetVessels.map((v: any) => ({ 'Name': v.name, 'Type': v.type, 'Description': v.description, 'Features': Array.isArray(v.features) ? v.features.join(', ') : '' })),
    contact: apiContactOffices.map((o: any) => ({ 'Office': o.name, 'City': o.city, 'Phone': Array.isArray(o.phoneNumbers) ? o.phoneNumbers.join(', ') : '', 'Email': o.email }))
  };
  const titles: Record<string, string> = { hero: 'Hero Settings', services: 'Services', fleet: 'Fleet Vessels', contact: 'Contact Offices' };
  printAsExcel(tabDataMap[activeTab] || [], `Website Settings - ${titles[activeTab]}`);
}
